var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10 7.37 4.4 7.37 10 2 10 7.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.4 7.55 4.4 21.98 19.6 22 19.6 2 10.14 2 4.4 7.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "18.97 5.99 16 5.99 16 14.53 13.95 14.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.72,
    y1: 10.66,
    x2: 11.76,
    y2: 10.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.71,
    cy: 10.78,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.21,
    cy: 14.53,
    r: 0.73
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAi);
export default __webpack_public_path__ + "static/media/DocumentAI.70147fe4255ddaf035f9d0403c242d63.svg";
export { ForwardRef as ReactComponent };